import * as tslib_1 from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import { env } from '@ivy/fts/envInfo/envInfo';
import openApp from '@ivy/fts/openApp';
let ChooseGiftDialog = class ChooseGiftDialog extends Vue {
    openVip() {
        if (env.type === 'ivydad') {
            env.commonJump('ivydadreadtool://my/vip');
        }
        else {
            openApp();
        }
    }
    close() {
        window.modals[window.modals.length - 1].close();
    }
};
ChooseGiftDialog = tslib_1.__decorate([
    Component({
        components: {},
    })
], ChooseGiftDialog);
export default ChooseGiftDialog;
